import {
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { ROUTES } from "../../constants";
import { Helmet } from "react-helmet-async";
import { DynamicForm } from "../../dynamicForm/forms/DynamicForm";
import React from "react";
import { useDynamicForm } from "../../dynamicForm/hooks/useDynamicForm";
import {
  newWellRegistrationFormConfig,
  PURPOSE_OF_WELL_FIELDS,
} from "../../dynamicForm/formConfigs/newWellRegistrationFormConfig";
import {
  ContentSkeleton,
  ErrorCard,
  PageContainer,
} from "../../dynamicForm/components/ui";

function validatePurposeOfWell(data) {
  const selected = PURPOSE_OF_WELL_FIELDS.filter((k) => data[k]);
  if (selected.length !== 1) {
    return [
      {
        path: [selected[0] ?? PURPOSE_OF_WELL_FIELDS[0]],
        message: "Select exactly one purpose type",
        type: "group",
      },
    ];
  }
  return [];
}

const IS_NEW = true;
const FORM_NDX = null;

export default function NewWellRegistrationPage() {
  const history = useHistory();
  const redirectPath = ROUTES.PUBLIC_FORMS;

  const handleRedirect = () => history.push(redirectPath);

  const { isFetching, error, refetchFormData, refetchLookups, ...rest } =
    useDynamicForm({
      ndx: FORM_NDX,
      isNewRecord: IS_NEW,
      config: newWellRegistrationFormConfig,
      endpoints: {
        submit: `/well-registration`,
      },
      handleRedirect,
      onSuccess: () => {},
      customValidate: validatePurposeOfWell,
    });

  const anyError = error;
  const loading = isFetching;
  const retryActions = [refetchFormData, refetchLookups].filter(Boolean);

  const pageTitle = "Well Construction Notification Application";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <Typography variant="h3" gutterBottom display="inline">
        {pageTitle}
      </Typography>
      <Breadcrumbs sx={{ mt: 4 }} aria-label="Breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <MuiLink component={RouterLink} to={ROUTES.PUBLIC_FORMS}>
          Forms
        </MuiLink>
        <Typography>Well Construction</Typography>
      </Breadcrumbs>
      <Divider sx={{ my: 6 }} />

      <PageContainer>
        {anyError ? (
          <ErrorCard
            onRetry={() => Promise.all(retryActions.map((action) => action()))}
            isFetching={loading}
          />
        ) : loading ? (
          <ContentSkeleton />
        ) : (
          <DynamicForm config={newWellRegistrationFormConfig} {...rest} />
        )}
      </PageContainer>
    </>
  );
}
